package com.banyan.flightviewer.web.components

import com.banyan.flightviewer.web.dom.bindFlow
import com.banyan.flightviewer.web.dom.div
import com.banyan.flightviewer.web.state.WebAppContainer
import org.w3c.dom.Element

fun mountStatusBar(parent: Element, app: WebAppContainer) {
    parent.div(className = "fv-statusbar") {
        app.appState.scope.bindFlow(app.appState.statusMessage) { msg ->
            textContent = msg
        }
    }
}
